/* eslint-disable @typescript-eslint/naming-convention */
import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    AfterViewChecked,
    AfterViewInit,
    DoCheck,
    IterableDiffers,
    ViewChildren,
    KeyValueDiffers,
    QueryList
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ArticleViewModel } from '../../models/ArticleViewModel';
import { ArticleComponentViewModel } from './article-component-viewmodel';
import { ArticleStatusEnum } from '../../enums/ArticleStatus.enum';
import { ContactsDataSource } from './contacts.datasource';
import { ContactLocalization } from './contact.localization';
import { LinksDataSource } from './links.datasource';
import { ArticleLocalization } from './article.localization';
import { Utils } from '../../utils/utils';
import { MessageService } from 'primeng/api';
import { PublishArticleComponentText } from './publish-article-component-text';
import { IdNamePairViewModel } from '../../models/IdNamePairViewModel';
import moment from 'moment-timezone';
import * as srcDoc from 'srcdoc-polyfill';
import { BodyContentTypesEnum } from '../../enums/BodyContentTypes.enum';
import { BodyContentsModel } from '../../models/BodyContentsModel';
import { PublishMetadataModel } from '../../../../Common/Dialogs/models/publish-metadata.model';
import { webVideoHelper } from '../../../../Common/Misc/helpers/webVideo/webVideo.helper';
import { FooterActionBarButtonModel } from '../../../../Common/Misc/models/footer-action-bar-button.model';
import { ContactsButtonModel } from '../../../Shared/components/Contacts/contacts-button.model';
import { ContactsButtonTypesEnum } from '../../../Shared/components/Contacts/contact-button-types.enum';
import { LinksButtonModel } from '../../../Shared/components/Links/links-button.model';
import { LinksButtonTypesEnum } from '../../../Shared/components/Links/links-button-types.enum';
import { ErrorTypeEnum } from '../../../Shared/enums/error-type.enum';
import { validateEmail } from '../../../../Common/Misc/helpers/formatting/email.helper';
import { DistributionRegionsEnum } from '../../enums/DistributionRegions.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ConfirmDialogComponent } from '../../../../Common/Dialogs/components/ConfirmDialog/confirm-dialog.component';
import { ScrollPanelComponent } from '../../../../Common/Basic/components/ScrollPanel/scroll-panel.component';
import { PublishStoryComponent } from '../../../../Common/Dialogs/components/PublishStory/publish-story.component';
import { PublishStoryDialogModel } from '../../../../Common/Dialogs/models/publish-story-dialog.model';

export const ArticleConstants = {
    sizeErrorMsgHeading: 'File Size Error',
    typeErrorMsgHeading: 'File Type Error',
    SaveFailedMsgHeading: 'Save failed',
    SubmitFailedMsgHeading: 'Submission Failed',
    SubmitFailedMsg: 'Press Release [[articleName]] could not be submitted.',
    SaveFailedMSG: 'Press release could not be saved',
    imageTypeError:  'Unsupported file type',
    imageErrorMessage:  'Unsupported image format',
    maxImageSizeError: 'File size may not exceed (1MB)',
    errorSeverity: 'error',
    publishReleaseLabel: 'Press Release Name',
    publishHeadlineLabel: 'Headline',
    publishCompanyNameLabel: 'Company Name',
    publishScheduleLabel: 'Scheduled Date',
    publishScheduleNow: 'Immediate',
    logoPlaceholder: 'Company Logo',
    cancelLabel: 'Cancel',
    retractLabel: 'Retract',
    retractConfirmHeading: 'Retract?',
    confirmMessage: 'Are you sure you want to retract this Press Release?',
};

@Component({
    selector: 'agpr-article',
    templateUrl: './article.component.html',
    styleUrls: ['./article.component.scss'],
    standalone: false
})
export class ArticleComponent implements AfterViewInit, DoCheck, AfterViewChecked {
    public growlTimeLimit: string = '3000';
    public minutesBeforeScheduledDateForCancellation: number = 60;
    public ukRegionHeadlineLimit: number = 50;
    public bodyFormattedTextLimit: number = 65500;
    public publishArticleLocalization: PublishArticleComponentText;
    public metadata: PublishMetadataModel[] = [];
    public disclaimers: string[] = [];
    public logoPlaceholder: string = ArticleConstants.logoPlaceholder;
    public showCompanyImageHtml: boolean = false;
    public showCompanyImageInput: boolean = false;
    public BodyContentTypes = BodyContentTypesEnum;
    public isFormDirty: boolean = false;
    public contactsDraftErrors: boolean = false;

    // TODO: Move all inputs and outputs toether and group them by type
    // for better readability
    @Input() public preferredMethodList: IdNamePairViewModel[] = [];
    @Input() minDate: Date = null;

    @ViewChild('frame')
    public iframe: ElementRef;

    private arrayDiffer: any;
    private keyValueDiffer: any;
    @ViewChild('companyLogo', { static: true }) companyLogoElement: ElementRef;
    @ViewChildren('bodyComponent') bodyContentsElements: QueryList<ElementRef>;
    @ViewChild('aboutUs') aboutUsElement: ElementRef;
    @ViewChild('contacts') contactsElement: ElementRef;
    @ViewChild('links') linksElement: ElementRef;
    private scrollToElementName: string;
    private scrollToBodyContentIndex: number;
    @ViewChild('scrollPanel', { static: true }) scrollPanel: ScrollPanelComponent;

    @Output() saveArticle: EventEmitter<void> = new EventEmitter<void>();

    public article: ArticleViewModel = new ArticleViewModel();
    @Input() set activeArticle(value: ArticleViewModel) {
        this.article = value;
        this.lastNotificationBodySafeHtml = this.domSanitizer.bypassSecurityTrustHtml(this.article.lastNotificationBody);
        this.setActionButtons();
    }
    @Input() showImagePlaceholder: boolean = true;
    @Input() viewModel: ArticleComponentViewModel = new ArticleComponentViewModel();


    @Input() contactsDataSource: ContactsDataSource = new ContactsDataSource();
    public contactButtons: ContactsButtonModel[] = [
        {
            buttonClick: new EventEmitter(),
            onButtonClickAction: function (item) {
            },
            iconClasses: 'fa-regular fa-duotone fa-trash-can',
            disabled: false,
            type: ContactsButtonTypesEnum.Delete
        },
        {
            buttonClick: new EventEmitter(),
            onButtonClickAction: function (item) {
            },
            iconClasses: 'fa-regular fa-duotone fa-pen',
            disabled: false,
            type: ContactsButtonTypesEnum.Edit
        },
        {
            buttonClick: new EventEmitter(),
            iconClasses: 'fa-regular fa-duotone fa-plus',
            disabled: false,
            type: ContactsButtonTypesEnum.Add
        },
    ];
    contactLocalizations: ContactLocalization = new ContactLocalization();
    @Input() showImageNormalMode: boolean = true;
    @Input() linksDataSource: LinksDataSource = new LinksDataSource();
    @Output() modelChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    articleLocalization: ArticleLocalization = new ArticleLocalization();

    btnSave: FooterActionBarButtonModel;
    btnUpdate: FooterActionBarButtonModel;
    btnPublish: FooterActionBarButtonModel;
    btnRetract: FooterActionBarButtonModel;
    actionButtons: FooterActionBarButtonModel[] = [];
    public linkButtons: LinksButtonModel[] = [
        {
            buttonClick: new EventEmitter(),
            iconClasses: 'fa-regular fa-duotone fa-trash-can',
            disabled: false,
            type: LinksButtonTypesEnum.Delete
        },
        {
            buttonClick: new EventEmitter(),
            iconClasses: 'fa-regular fa-duotone fa-pen',
            disabled: false,
            type: LinksButtonTypesEnum.Edit
        },
        {
            buttonClick: new EventEmitter(),
            iconClasses: 'fa-regular fa-duotone fa-plus',
            disabled: false,
            type: LinksButtonTypesEnum.Add
        },
    ];

    showImageHtml: boolean = true;
    showImageInput: boolean = false;
    showDeleteButton: boolean = true;
    isLinkDirty: boolean = false;
    public storyInfo: boolean = true;
    public isLoader: boolean = false;
    public lastNotificationBodySafeHtml: SafeHtml;

    constructor(
        public domSanitizer: DomSanitizer,
        iterableDiffers: IterableDiffers,
        keyValueDiffers: KeyValueDiffers,
        private messageService: MessageService,
        private coreDialogService: CoreDialogService
    ) {
        this.btnSave = new FooterActionBarButtonModel (this.articleLocalization.saveButtonText, true, false);
        this.btnUpdate = new FooterActionBarButtonModel (this.articleLocalization.updateButtonText, true, false);
        this.btnPublish = new FooterActionBarButtonModel (this.articleLocalization.publishButtonText, true, false);
        this.btnRetract = new FooterActionBarButtonModel (this.articleLocalization.retractButtonText, true, false);
        this.btnSave.click.subscribe( results => {
            this.showSupportDialog();
        });
        this.btnUpdate.click.subscribe(results => {
            this.showSupportDialog();
        });
        this.btnPublish.click.subscribe(results => {
            this.showSupportDialog();
        });
        this.publishArticleLocalization = new PublishArticleComponentText();
        this.btnRetract.click.subscribe(results => {
            this.showSupportDialog();
        });
        this.disclaimers = [
            this.articleLocalization.disclaimer1Text,
            this.articleLocalization.disclaimer2Text
        ];
        this.arrayDiffer = iterableDiffers.find([]).create(null);
        this.keyValueDiffer = keyValueDiffers.find({}).create();
    }

    ngAfterViewInit() {
        const isDisplayIframe = this.displayiFrame();
        if (isDisplayIframe) {
            this.applySrcdocPollyfill();
        }
    }
    ngDoCheck() {
        // check for changes to the article body contents
        const changedBodyContents = this.arrayDiffer.diff(this.article.bodyContents);
        // check for changes to the article view model
        const changedViewState = this.keyValueDiffer.diff(this.viewModel);
        // if there are too many changes, then we don't know what to scroll to
        let numberOfChanges = 0;

        // a bodyContent item may have been added
        if (changedBodyContents) {
            this.scrollToElementName = 'bodyContentsElements';
            changedBodyContents.forEachAddedItem((item) => {
                this.scrollToBodyContentIndex = item.currentIndex;
                numberOfChanges++;
            });
        }

        // a different optional component may have been added
        if (changedViewState) {
            changedViewState.forEachChangedItem((item) => {
                // Only care if the currentValue is true, because that means it was added to the screen
                if (item.currentValue === true) {
                    switch (item.key) {
                        case 'showLogo':
                            this.scrollToElementName = 'companyLogoElement';
                            break;
                        case 'showContacts':
                            this.scrollToElementName = 'contactsElement';
                            break;
                        case 'showAboutUs':
                            this.scrollToElementName = 'aboutUsElement';
                            break;
                        case 'showLinks':
                            this.scrollToElementName = 'linksElement';
                            break;
                    }
                }
                numberOfChanges++;
            });
        }

        if (numberOfChanges !== 1) {
            // if there are too many changes, then we don't know what to scroll to
            this.scrollToBodyContentIndex = null;
            this.scrollToElementName = null;
        }
    }
    ngAfterViewChecked() {
        // if we found a new item
        if (this.scrollToElementName) {
            let element: ElementRef;
            // then find it's element on the screen now that it exists
            if (this.scrollToElementName === 'bodyContentsElements') {
                // it's one of the bodyContent elements
                element = this.bodyContentsElements.toArray()[this.scrollToBodyContentIndex];
            } else {
                // it's a different optional element
                element = this[this.scrollToElementName];
            }

            // clear the scrollTo so we don't try again if something goes wrong
            this.scrollToBodyContentIndex = null;
            this.scrollToElementName = null;

            // scroll to it if we can
            if (element) {
                this.scrollPanel.scrollIntoView(element);
            }
        }
    }

    public applySrcdocPollyfill() {
        // eslint-disable-next-line max-len
        const iframeContentWrapperOpen = '<style type=\'text/css\' ref=\'all\'>.iframe-content-wrapper { font-family: Helvetica, Arial, sans-serif; word-break: break-word; } img { max-width: 100%; } p, h5, a {font-size: 0.8125rem!important; word-break: break-word;} a:link { color:#005494; text-decoration: none; }a:visited { color: #005494; text-decoration: none; }a:hover { color: #005494; text-decoration: none; }a:active { color:#005494; text-decoration: underline; }</style><div class=\'iframe-content-wrapper\'>';
        const iframeContentWrapperClose = '</div>';
        this.article.lastNotificationBody = iframeContentWrapperOpen + this.article.lastNotificationBody + iframeContentWrapperClose;
        if (this.iframe.nativeElement && this.article.lastNotificationBody) {
            srcDoc.set(this.iframe.nativeElement, this.article.lastNotificationBody);
        }
    }

    public displayFooterActionBar(): boolean {
        const display: boolean = this.article.articleStatus !== ArticleStatusEnum.Posted;
        return display;
    }
    public displayiFrame(): boolean {
        const display: boolean = ((this.article.articleStatus === ArticleStatusEnum.Scheduled || this.article.articleStatus === ArticleStatusEnum.Posted)
        && this.article.lastNotificationBody != null);
        return display;
    }

    onModelChanged(): void {
        this.isFormDirty = true;
        this.actionButtons.splice(0, this.actionButtons.length);
        this.actionButtons.push(this.btnSave);
        this.modelChange.emit(true);
    }

    doPublish(confirmed: boolean): void {
        if (confirmed) {
            this.article.articleStatus = ArticleStatusEnum.InReview;
            this.saveArticle.emit();
        }
    }

    onLinkControlDelete(): void {
        this.viewModel.showLinks = false;
        this.article.links = [];
    }

    showImageError(errorType: string): void {
        if (errorType === ErrorTypeEnum.ImageFileType) {
            this.ShowMessage(ArticleConstants.typeErrorMsgHeading, ArticleConstants.imageTypeError, ArticleConstants.errorSeverity);
        }
        if (errorType === ErrorTypeEnum.ImagefileSize) {
            this.ShowMessage(ArticleConstants.sizeErrorMsgHeading, ArticleConstants.maxImageSizeError, ArticleConstants.errorSeverity);
        }
    }
    public ShowMessage(headMessage: string, Detailmessage: string, messageSeverity: string) {
        this.messageService.add({severity: messageSeverity, summary: headMessage, detail: Detailmessage});
    }

    // @Deprecated - We now show the support dialog
    onSaveClick(): void {
        this.removeEmptyLinks();
        this.removeEmptyContacts();
        if (!this.validateSaveData()) {
            this.ShowMessage(ArticleConstants.SaveFailedMsgHeading, ArticleConstants.SaveFailedMSG, ArticleConstants.errorSeverity);
            return;
        }
        this.saveArticle.emit();
    }

    removeEmptyLinks() {
        if (this.linksDataSource.dataSource.length > 0) {
            this.linksDataSource.dataSource.forEach(function (articleLink, index, object) {
                if (articleLink.webAddress === '') {
                    object.splice(index, 1);
                }
            });
        }
    }

    removeEmptyContacts() {
        let count = this.contactsDataSource.dataSource.length;
        if (count > 0) {
            while (count--) {
                const articleContact = this.contactsDataSource.dataSource[count];
                if (
                    !articleContact.name
                    && !articleContact.title
                    && !articleContact.emailAddress
                    && !articleContact.address
                    && !articleContact.phoneNumber
                    && !articleContact.mobileNumber
                    && !articleContact.webAddress
                    && !articleContact.imageData
                    && !articleContact.imageId
                ) {
                    this.contactsDataSource.dataSource.splice(count, 1);
                }
            }
        }
    }

    validateSaveData(): boolean {
        this.viewModel.showDraftErrors = false;
        this.viewModel.showPublishErrors = false;
        this.checkForContactsEmailError();

        if (Utils.isNullOrEmpty(this.article.articleName)) {
            this.viewModel.showDraftErrors = true;
            return false;
        }

        if (!Utils.isNullOrEmpty(this.article.contactEmail) && !validateEmail(this.article.contactEmail)) {
            this.viewModel.showDraftErrors = true;
            return false;
        }

        if (this.contactsDraftErrors) {
            this.viewModel.showDraftErrors = true;
            return false;
        }

        if (!Utils.isNullOrEmpty(this.article.body) && this.article.body.length > this.bodyFormattedTextLimit) {
            return false;
        }

        for (const bodyContent of this.article.bodyContents) {
            if (bodyContent.bodyContentType === BodyContentTypesEnum.Text) {
                if (!Utils.isNullOrEmpty(bodyContent.bodyContent) && bodyContent.bodyContent.length > this.bodyFormattedTextLimit) {
                    return false;
                }
            }
        }
        return true;
    }

    // @Deprecated - we now show the support dialog
    onRetractClick(): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            {
                inputs: {
                    heading: ArticleConstants.retractConfirmHeading,
                    message: ArticleConstants.confirmMessage,
                    okLabel: ArticleConstants.retractLabel,
                    cancelLabel: ArticleConstants.cancelLabel
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            this.article.articleStatus = ArticleStatusEnum.Retracted;
                            this.saveArticle.emit();
                        }
                    }
                }
            }
        );
    }

    public showSupportDialog(): void {
        this.coreDialogService.open(
            ConfirmDialogComponent,
            {
                inputs: {
                    id: 'newsire.confirmdialog',
                    width: 500,
                    heading: 'Newswire',
                    messageHtml: 'We are currently upgrading your wire distribution options and improving the newswire submission process.<br/><br/>' +
                        'While we are completing this, your newswire requirements will be processed by your Agility Support team.<br/><br/>' +
                        // eslint-disable-next-line max-len
                        'Please submit your release and supporting information <a href="https://www.agilitypr.com/newswire-provisioning-form" target="_blank">here</a> and we will be in touch ASAP. Please note that all wire releases have associated costs, which can be provided by your Agility account representative.<br/><br/>' +
                        'Please contact <a href="https://www.agilitypr.com/support" target="_blank">Agility Support</a> with any questions.',
                    okLabel: 'Create Press Release'
                },
                outputs: {
                    dialogClose: (confirmed: boolean) => {
                        if (confirmed) {
                            window.open('https://www.agilitypr.com/newswire-provisioning-form');
                        }
                    }
                }
            }
        );
    }

    // @Deprecated - We now just show the support dialog
    onPublishClick(): void {
        if (!this.validatePublishData()) {
            this.ShowMessage(
                ArticleConstants.SubmitFailedMsgHeading,
                ArticleConstants.SubmitFailedMsg.replace('[[articleName]]', this.article.articleName),
                ArticleConstants.errorSeverity
            );
            return;
        }
        this.metadata = [
            new PublishMetadataModel(ArticleConstants.publishReleaseLabel, this.article.articleName),
            new PublishMetadataModel(ArticleConstants.publishHeadlineLabel, this.article.headline),
            new PublishMetadataModel(ArticleConstants.publishCompanyNameLabel, this.article.companyName)
        ];
        if (+this.article.scheduledDate > +new Date) {
            let momentDate = moment(this.article.scheduledDate);
            if (this.article.timeZone) {
                momentDate = momentDate.tz(this.article.timeZone);
            } else {
                momentDate = momentDate.tz('UTC');
            }
            const dateFormat = momentDate.format('MMM, DD YYYY hh:mm A z');
            this.metadata.push(new PublishMetadataModel(ArticleConstants.publishScheduleLabel, dateFormat));
        } else {
            // if not set or in the past, then schedule is "immediate"
            this.metadata.push(new PublishMetadataModel(ArticleConstants.publishScheduleLabel, ArticleConstants.publishScheduleNow));
        }
        this.openPublishDialog();
        this.storyInfo = true;
    }

    validatePublishData(): boolean {
        this.viewModel.showDraftErrors = false;
        this.viewModel.showPublishErrors = false;
        for (const bodyContent of this.article.bodyContents) {
            if (bodyContent.bodyContentType === BodyContentTypesEnum.Video) {
                if (!webVideoHelper.isYoutubeURL(bodyContent.bodyContent)) {
                    this.viewModel.showPublishErrors = true;
                    return false;
                }
            }
        }
        if (
            Utils.isNullOrEmpty(this.article.articleName)
            || Utils.isNullOrEmpty(this.article.headline)
            || Utils.isNullOrEmpty(this.article.companyName)
            || Utils.isNullOrEmpty(this.article.body)
            || Utils.isNullOrEmpty(this.article.datelineLocation)
            || this.article.regions.length < 1
            || this.article.preferredMethodId === null
            || Utils.isNullOrEmpty(this.article.contactName)
            || Utils.isNullOrEmpty(this.article.contactPhone)
            || (Utils.isNullOrEmpty(this.article.contactEmail) && !validateEmail(this.article.contactEmail))
            || this.article.scheduledTime.hour === null || this.article.scheduledTime.hour === undefined
            || this.article.scheduledTime.minute === null || this.article.scheduledTime.minute === undefined
            || this.article.datelineDate === undefined || this.article.datelineDate === null
            || this.minDate && this.article.scheduledDate < this.minDate
            || this.article.industryId === null || this.article.industryId === undefined
            || !this.validateUKHeadlineLength()
        ) {
            this.viewModel.showPublishErrors = true;
            return false;
        }

        return true;
    }

    validateUKHeadlineLength(): boolean {
        if (this.article.regions.includes(DistributionRegionsEnum.UK) && !Utils.isNullOrEmpty(this.article.headline)) {
            return this.article.headline.length <= this.ukRegionHeadlineLimit;
        }
        return true;
    }

    public checkForContactsEmailError(): void {
        const contacts = this.contactsDataSource.dataSource;
        let invalidEmail: boolean = false;
        contacts.forEach((contact) => {
            if (contact.emailAddress) {
                if (!validateEmail(contact.emailAddress)) {
                    invalidEmail = true;
                }
            }
        });
        this.contactsDraftErrors = invalidEmail;
    }

    getPreferredMethodId(name: string): number {
        const preferredMethod = this.preferredMethodList.find(method => {
            return method.name === name;
        });
        return +preferredMethod.id;
    }

    isDataEntryDisabled(): boolean {
        // @Deprecated - we don't allow editing anymore
        // return this.article.articleStatus != null && this.article.articleStatus !== ArticleStatusEnum.Draft;
        return true;
    }

    setActionButtons(): void {
        this.actionButtons = [];
        let minutesToScheduled: number = -1;
        if (this.article.scheduledDate != null) {
            minutesToScheduled = ((this.article.scheduledDate.getTime() / 1000) - moment.utc().unix()) / 60;
        }
        if (this.article.articleStatus == null) {
            this.actionButtons.push(this.btnSave);
        } else if (this.article.articleStatus === ArticleStatusEnum.Draft) {
            this.actionButtons.push(this.btnPublish);
        } else if ((this.article.articleStatus === ArticleStatusEnum.InReview || this.article.articleStatus === ArticleStatusEnum.Scheduled)
        && this.article.scheduledDate != null
        && minutesToScheduled > this.minutesBeforeScheduledDateForCancellation) {
            this.actionButtons.push(this.btnRetract);
        }
    }

    deleteAboutUs(): void {
        this.viewModel.showAboutUs = false;
        if (!Utils.isNullOrEmpty(this.article.aboutUs) && !this.isFormDirty) {
            this.onModelChanged();
        }
        this.article.aboutUs = '';
    }

    onContactControlDelete(): void {
        this.viewModel.showContacts = false;
    }

    deleteBodyContent(bodyContent: BodyContentsModel): void {
        const index = this.article.bodyContents.indexOf(bodyContent);
        this.article.bodyContents.splice(index, 1);
        if (!Utils.isNullOrEmpty(bodyContent.bodyContent) && !this.isFormDirty) {
            this.onModelChanged();
        } else {
            this.modelChange.emit(false);
        }
    }

    getBrowsedImage(imageData: string, bodyContent: BodyContentsModel): void {
        if (!Utils.isNullOrEmpty(imageData) || !Utils.isNullOrEmpty(bodyContent.bodyContent)) {
            this.onModelChanged();
        }
        bodyContent.bodyContent = imageData;
    }

    deleteLogo(event): void {
        if (!Utils.isNullOrEmpty(this.article.companyLogo) && !this.isFormDirty) {
            this.onModelChanged();
        }
        this.viewModel.showLogo = false;
        this.article.companyLogo = null;
    }

    getBrowsedLogo(imageData: string): void {
        if (!Utils.isNullOrEmpty(imageData) || !Utils.isNullOrEmpty(this.article.companyLogo)) {
            this.onModelChanged();
        }
        this.article.companyLogo = imageData;
    }

    moveBodyContentUp(index: number): void {
        if (index < 1) {
            return;
        }
        const bodyContentA = this.article.bodyContents[index];
        const bodyContentB = this.article.bodyContents[index - 1];
        this.article.bodyContents[index] = bodyContentB;
        this.article.bodyContents[index - 1] = bodyContentA;
        this.onModelChanged();
    }
    moveBodyContentDown(index: number): void {
        if (index >= this.article.bodyContents.length - 1) {
            return;
        }
        const bodyContentA = this.article.bodyContents[index];
        const bodyContentB = this.article.bodyContents[index + 1];
        this.article.bodyContents[index] = bodyContentB;
        this.article.bodyContents[index + 1] = bodyContentA;
        this.onModelChanged();
    }

    public openPublishDialog(): void {
        const io: PublishStoryDialogModel = {
            inputs: {
                id: 'Newswire.story.publish',
                headerIcon: 'agpr-i-line-globe',
                header: 'Submit for Review',
                metadata: this.metadata,
                storyInfo: this.storyInfo,
                localization: this.publishArticleLocalization,
                disclaimers: this.disclaimers
            },
            outputs: {
                dialogClose: (confirmed: boolean) => {
                    this.doPublish(confirmed);
                }
            }
        };
        this.coreDialogService.open(PublishStoryComponent, io);
    }
}
